import { Box, Button, FormControl, MenuItem, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  ButtonComponent,
  FieldWrapper,
  FilterContainer,
  InputSearch,
  ResetButton,
} from "../common/ListingFilter.style";
import { SearchBox } from "../common/SearchBox";
import { useState } from "react";
import dayjs from "dayjs";

type LabRequisitionsFilterProps = {
  fromDate?: dayjs.Dayjs;
  onSetFromDate: (value: dayjs.Dayjs) => void;
  toDate?: dayjs.Dayjs;
  onSetToDate: (value: dayjs.Dayjs) => void;
  status: string | undefined;
  onSetStatus: (value: string | undefined) => void;
  onFilterButtonClick: () => void;
  onResetButtonClick: () => void;
  onSearch: (value: string) => void;
};

const statusOptions = [
  { label: "All", value: "ALL" },
  { label: "Pending", value: "PENDING" },
  { label: "Order Placed", value: "ORDER_PLACED" },
  { label: "Failed", value: "FAILED" },
];

export default function LabRequisitionsFilter({
  fromDate,
  onSetFromDate,
  toDate,
  onSetToDate,
  status,
  onSetStatus,
  onFilterButtonClick,
  onResetButtonClick,
  onSearch,
}: LabRequisitionsFilterProps) {
  const [search, setSearch] = useState("");

  const onSearchChange = (text: string) => {
    setSearch(text);
    onSearch(text);
  };

  const onSearchClear = () => {
    setSearch("");
    onSearch("");
  };

  return (
    <Box>
      <FilterContainer>
        <FieldWrapper>
          <InputSearch variant="outlined" fullWidth>
            <SearchBox
              placeholderLabel="Search by Patient Name / Lab Order ID"
              searchTestId="search-patient-name-or-lab-order-id"
              searchText={search}
              onSearchTextChange={onSearchChange}
              onSearchClear={onSearchClear}
            />
          </InputSearch>
        </FieldWrapper>
      </FilterContainer>
      <FilterContainer>
        <FieldWrapper>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From Date"
              value={fromDate ?? null}
              onChange={value => value && onSetFromDate(value)}
              maxDate={toDate ?? dayjs()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  onKeyDown: event => {
                    event.preventDefault();
                  },
                  slotProps: {
                    htmlInput: {
                      "data-testid": "from-date-picker",
                    } as React.InputHTMLAttributes<HTMLInputElement>,
                    input: {
                      readOnly: true,
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </FieldWrapper>
        <FieldWrapper>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              value={toDate ?? null}
              onChange={value => value && onSetToDate(value)}
              maxDate={dayjs()}
              minDate={fromDate}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  //inputProps: { "data-testid": "to-date-picker" },
                  onKeyDown: event => {
                    event.preventDefault();
                  },
                  // InputProps: {
                  //   readOnly: true,
                  // },
                  slotProps: {
                    htmlInput: {
                      "data-testid": "to-date-picker",
                    } as React.InputHTMLAttributes<HTMLInputElement>,
                    input: {
                      readOnly: true,
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </FieldWrapper>
        <FieldWrapper>
          <FormControl component="form" noValidate fullWidth autoComplete="off">
            <Box>
              <TextField
                //inputProps={{ "data-testid": "select-status" }}
                slotProps={{
                  htmlInput: { "data-testid": "select-status" },
                }}
                id="outlined-select-status"
                select
                label="Status"
                fullWidth
                size="small"
                value={status ?? "ALL"}
                onChange={e => {
                  const value =
                    e.target.value === "ALL" ? undefined : e.target.value;
                  onSetStatus(value);
                }}
              >
                {statusOptions.map(option => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </FormControl>
        </FieldWrapper>
      </FilterContainer>
      <ButtonComponent>
        <ResetButton
          variant="outlined"
          size="small"
          onClick={onResetButtonClick}
          data-testid="reset-button"
        >
          Reset
        </ResetButton>
        <Button
          variant="contained"
          size="small"
          onClick={onFilterButtonClick}
          data-testid="filter-button"
        >
          Filter
        </Button>
      </ButtonComponent>
    </Box>
  );
}
